export default __webpack_public_path__ + "static/media/sea.746b5dd9.svg";